export default "__VITE_ASSET__99a08b57__"